import React, {useCallback} from 'react';
import {ReactComponent as DownloadIcon} from '../../../../../assets/main/groups/main-table/download.svg';
import {ReactComponent as PrintIcon} from '../../../../../assets/main/groups/main-table/print.svg';
import {ReactComponent as TooltipIcon} from '../../../../../assets/main/groups/main-top/tooltip.svg';
import {Act} from "features/model/types/payments/actsSchema";
import {getActsPdf} from "features/model/service/payments/acts/acts-pdf/getActsPdf";
import {useAppDispatch} from "common/hook";
import {printActsPdf} from "features/model/service/payments/acts/acts-pdf/printActPdf";


interface IActsItemProps {
    acts: Act;
}


export const ActsItems = ({acts}: IActsItemProps) => {
    const dispatch = useAppDispatch();

    const downloadPdfHandler = useCallback(
        async (actId: number) => {
            try {
                await dispatch(getActsPdf(actId));
            } catch (error) {
                console.error('Error downloading PDF', error);
            }
        },
        [dispatch]
    );


    const printPdfHandler = useCallback(async (actId: number) => {
        if (actId) {
            try {
                const action = await dispatch(printActsPdf(actId));
                const url = action.payload as string | URL;
                if (url) {
                    window.open(url.toString(), "_blank");
                }
            } catch (error) {
                console.error("Error opening PDF", error);
            }
        }
    }, [dispatch]);

    return (
        <div className="row">
            <div className="col download-col auto-width full-width-mobile">
                <span className="col-title">Название акта</span>
                <p>
                    <a style={{cursor: 'pointer'}} onClick={() => downloadPdfHandler(acts.id)}>
                        {acts.fileName}
                    </a>
                </p>
                <p className="sub-data">{acts.userName}</p>
                <span
                    className="download-btn"
                    onClick={() => downloadPdfHandler(acts.id)}
                >
                <DownloadIcon/>
                </span>
            </div>
            <div className="col period-col full-width-mobile">
                <span className="col-title">Период</span>
                <p>{acts.period}</p>
            </div>
            <div className="col date-col full-width-mobile">
                <span className="col-title">Дата выставления</span>
                <p>{acts.date}</p>
            </div>
            <div className="col lesson-count-col align-right full-width-mobile">
                <span className="col-title">Количество занятий</span>
                <p>{acts.numberLessons}</p>
            </div>
            <div className="col lesson-cost-col align-right full-width-mobile">
                <span className="col-title">Стоимость занятия</span>
                <p className={`price ${acts.lessonPrice === 0 ? 'p-icon inactive' : ''}`}>
                    {acts.lessonPrice} {acts.currency}
                    {acts.lessonPrice === 0 && (
                        <div className="icon new-tooltip">
                                    <span className="icon pointer-elem">
                                        <TooltipIcon/>
                                    </span>
                            <div className="tooltip-text">Tooltip Text Description</div>
                        </div>
                    )}
                </p>
            </div>

            <div className="col total-sum-col align-right full-width-mobile">
                <span className="col-title">Сумма</span>
                <p className={`price ${acts.amount === 0 ? 'p-icon inactive' : ''}`}>
                    <strong>{acts.amount} {acts.currency}</strong>
                    {acts.amount === 0 && (
                        <div className="icon new-tooltip">
                                    <span className="icon pointer-elem">
                                        <TooltipIcon/>
                                    </span>
                            <div className="tooltip-text">Tooltip Text Description</div>
                        </div>
                    )}
                </p>
            </div>
            <div className="col btn-link-col print-col">
                <span
                    className="print-btn"
                    onClick={() => printPdfHandler(acts.id)}
                >
                    <PrintIcon
                    />
                </span>
            </div>
        </div>
    );
};
